// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2BA_W","content":"styles_content__2DUMA","selectAll":"styles_selectAll__19G7Z"};